'use client'

import { useSiteConfig } from '@/feature/config/hooks/useSiteConfig.client'
import type { PointOfSale } from '@gql-generated/graphql'
import { useCallback } from 'react'

export interface PointOfSaleWithNameFields {
  distributionNetworkLabel?: PointOfSale['distributionNetworkLabel']
  subsidiary?: StrictPick<PointOfSale['subsidiary'], 'name'> | null
}

export function usePointOfSaleNameFormatter() {
  const siteConfig = useSiteConfig()
  const isSubsidiaryDisplayEnabled = siteConfig.config?.pointOfSale?.isSubsidiaryDisplayEnabled

  return useCallback(
    (pointOfSale?: PointOfSaleWithNameFields | null): string => {
      if (!pointOfSale) return ''

      return [
        pointOfSale.distributionNetworkLabel,
        isSubsidiaryDisplayEnabled && pointOfSale.subsidiary?.name,
      ]
        .filter(Boolean)
        .join(' ')
    },
    [isSubsidiaryDisplayEnabled],
  )
}
